import React from 'react';
import PropTypes from 'prop-types';
import { MdReorder } from 'react-icons/md';
import styled from 'styled-components';
import { ReactSortable } from 'react-sortablejs';
import Dialog from './Dialog';
import em from '../raketa-ui/em';
import { WIDGET_LIST } from '../../widgets';

const ReorderDialogItem = styled.div `
  display: flex;
  align-items: center;
  padding: ${em(0.5)};
  margin-bottom: ${em(0.5)};
  border: 1px solid ${props => props.theme.buttonColor};
  color: ${props => props.theme.sideNavColor};
  cursor: move;

  h6 {
    margin-bottom: 0;
    margin-left: ${em(0.5)}
  }
`;

const ReorderWidgetsDialog = ({
  open,
  onClose,
  onChange,
  widgets = [],
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    title="Reorder Layout"
    primaryLabel=""
    secondaryLabel="Close"
  >
    <p>Drag and drop elements to reorder content.</p>

    <ReactSortable
      list={widgets.map(w => ({ ...w, id: w.widgetId }))}
      setList={onChange}
      handle=".btn-drag"
      animation={150}
      tag="div"
    >
      {widgets.map((widget) =>
        <div key={widget.widgetId}>
          <ReorderDialogItem className="btn-drag">
            <MdReorder />
            <h6>{WIDGET_LIST[widget.component].title}</h6>
          </ReorderDialogItem>
        </div>)}
    </ReactSortable>
  </Dialog>
);

ReorderWidgetsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  widgets: PropTypes.array,
};

export default ReorderWidgetsDialog;
